import { makeObservable, observable, flow } from 'mobx';

// This will load all tasks for all stores the user has access to.

class TaskStore {
    constructor(api) {
        this._tasks = [];

        this.loading = true;

        this._api = api;

        makeObservable(
            this,
            {
                loading: observable,
                _tasks: observable,
                load: flow,

                deleteTask: flow,
                createTaskAsync: flow,
                updateTaskState: flow,
            }
        );
    }

    *load() {
        const res = yield this._api.axios.get('/tasks');

        this._tasks = res.data.tasks.filter(e => e.state !== 'delivered');
        this.loading = false;
    }

    get tasks() {
        return this._tasks;
    }

    *deleteTask(taskIds) {
        const res = yield this._api.axios.delete(
            '/tasks',
            { params: { taskIds }}
        );

        const deletedSet = new Set(res.data.deleted);

        this._tasks = this._tasks.filter(e => !deletedSet.has(e.id));
    }

    *createTaskAsync(task) {
        const res = yield this._api.axios.post('/tasks', task);

        this._tasks = [...this._tasks, { ...res.data.task }];
    }

    *updateTaskState(id, state) {
        const idx = this._tasks.findIndex(e => e.id === id);
        if (idx < 0) return;

        const res = yield this._api.axios.put('/tasks/state', { taskId: id, state });

        this._tasks = this._tasks.toSpliced(idx, 1, res.data);
    }
}

export { TaskStore };
